import React from 'react';
import { Header } from '../../node_modules/semantic-ui-react';

export default function AboutMe(props) {
    return (
        <div className='section' id='aboutMe'>
            <Header as='h3'>
                About Me
            </Header>
            <div className="section-content">
                <p>
                    I build interactive systems to help learning become easier. In my current research, I use multi-modal inputs including text, audio, and video
                    to facilitate effective foreign language learning. <span className="keyword">Crowdsourcing</span> and <span className="keyword">video interfaces</span> are 
                    the two keywords of my research interest. I'm interested in building interactive systems where the users
                    improve the system through their voluntary contributions in a form of crowdsourcing. 
                    I work with <a className='underline' href='https://www.juhokim.com'> Juho Kim</a> and awesome members in <a className='underline' href='https://www.kixlab.org'>KIXLAB</a> at <a className='underline' href='https://www.kaist.ac.kr'>KAIST</a>.
                </p>
                <p>
                    {/* Other than research, I spend most of my times doing a lot of sports like football (or soccer), golf, and Jiu-jitsu, which I enjoy as much as I love watching them.  */}
                    If you wish to talk to me, the <a href="mailto:kyungjejo@kaist.ac.kr" className="underline">email</a> is the best way.
                </p>
            </div>
        </div>
    )
}  


// WEBPACK FOOTER //
// ./src/components/AboutMe.jsx